// AG-Grid does not come with translations... we gotta provide them

// set the locale-specific translations object to the agGrid.localeText prop for <ag-grid-vue>

// import AgGridLocaleEnUs from './en-us-REFERENCE';  // the default agGrid strings are American English
import { normalizeLocale, enumeratePossibleLocales } from '@/localization/utils';  // utils for working with localization / i18n machinery
import AgGridLocaleEs from './locales/es';
import AgGridLocalePt from './locales/pt';
import AgGridLocaleSv from './locales/sv';
import AgGridLocaleZhHans from './locales/zh-Hans';
import AgGridLocaleZhHant from './locales/zh-Hant';


// KEYS HERE ARE THE "NORMALIZED" LOCALE CODES (passed through normalizeLocale() which creates Intl.Locale and returns the baseName)
// examples:  'en-US', 'en-GB', 'es', 'es-MX', 'pt', 'pt-BR', 'sv', 'zh-Hans', 'zh-Hant', etc...
const agGridLocales = {
    'en': null,  // use the default agGrid strings (American English)
    'en-US': null,  // use the default agGrid strings (American English)
    'en-GB': null,  // use the default agGrid strings (American English... can make UK English version later if needed)
    'es': AgGridLocaleEs,
    'es-MX': AgGridLocaleEs,  // use the same as 'es' for now
    'es-ES': AgGridLocaleEs,  // use the same as 'es' for now
    'pt': AgGridLocalePt,
    'pt-BR': AgGridLocalePt,  // use the same as 'pt' for now
    'pt-PT': AgGridLocalePt,  // use the same as 'pt' for now
    'sv': AgGridLocaleSv,
    // simplified Chinese
    'zh': AgGridLocaleZhHans,  // if only 'zh' we assume simplified!
    'zh-Hans': AgGridLocaleZhHans,
    'zh-Hans-CN': AgGridLocaleZhHans,  // use the same as 'zh-Hans' for now
    'zh-CN': AgGridLocaleZhHans,  // use the same as 'zh-Hans' for now
    // traditional Chinese
    'zh-Hant': AgGridLocaleZhHant,
    'zh-Hant-TW': AgGridLocaleZhHant,  // use the same as 'zh-Hant' for now
    'zh-TW': AgGridLocaleZhHant,  // use the same as 'zh-Hant' for now
    'zh-HK': AgGridLocaleZhHant,  // use the same as 'zh-Hant' for now
    'zh-MO': AgGridLocaleZhHant,  // use the same as 'zh-Hant' for now
};

/**
 * 
 * @param {string|Intl.Locale} locale - the locale code (e.g., 'en', 'es-MX', 'es', 'zh-Hans-CN', 'fr') or an Intl.Locale object
 * @returns {object|null} - the localeText object for agGrid or null to use default English strings
 * 
 * get the locale from the mixin computed property $splLocale, then call this function to get the localeText object for agGrid
 * 
 * Usage:
 * import getAgGridLocaleText from './localization/shared/agGrid';
 * 
 * const agGridLocaleText = getAgGridLocaleText(this.$splLocale);
 */
const getAgGridLocaleText = (locale) => {
    if (!locale) return null;  // use default English strings
    const normalizedLocale = normalizeLocale(locale);  // returns the .baseName of the locale (e.g., 'en', 'es', 'es-MX', 'zh-Hans-CN', 'fr', etc.)
    const possibleLocales = enumeratePossibleLocales(normalizedLocale);
    for (const loc of possibleLocales) {
        if (loc in agGridLocales) {
            console.log(`getAgGridLocaleText: found/using locale '${loc}' for agGrid`);
            return agGridLocales[loc];
        }
    }
    // fallback to default English strings by returning null
    console.log(`getAgGridLocaleText: no locale found for '${normalizedLocale}', using default for agGrid`);
    return null;
};

export default getAgGridLocaleText;